@if (memberships.length > 0 && !showCreateView) {

  <div class="member-view">
    <div class="fee-page-back-row">
      <button type="button" class="back-button" (click)="goBack()" aria-label="Back">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="#12314F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <div class="member-detail">

      @if (profileLoading) {
        <div class="detail-state">
          <mat-progress-spinner diameter="36" mode="indeterminate"></mat-progress-spinner>
        </div>
      } @else if (memberProfile && activeMembership) {
        <div class="profile-layout">
          <aside class="info-panel desktop-only">
            <div class="info-card info-card--full">
              <div class="card-top-row">
                <h2 class="user-name">{{ memberProfile.name }}</h2>
              </div>

              <div class="user-fields">
                <div class="field-row"><span class="field-label">{{ 'fee.member_id' | translate }}:</span><span class="field-value">{{ memberProfile.userId || memberProfile.id }}</span></div>
                <div class="field-row"><span class="field-label">{{ 'fee.passport_or_id_card' | translate }}:</span><span class="field-value">{{ memberProfile.passportId || '—' }}</span></div>
                <div class="field-row"><span class="field-label">{{ 'fee.date_of_birth' | translate }}:</span><span class="field-value">{{ formatDate(memberProfile.dateOfBirth) }}</span></div>
                <div class="field-row"><span class="field-label">{{ 'fee.mail' | translate }}:</span><span class="field-value">{{ memberProfile.email || '—' }}</span></div>
                <div class="field-row"><span class="field-label">{{ 'fee.phone' | translate }}:</span><span class="field-value">{{ memberProfile.phone || '—' }}</span></div>
              </div>

              <div class="card-divider"></div>
              <div class="field-row">
                <span class="field-label">{{ 'activity.status' | translate }}:</span>
                <span class="field-value status-text" [class.status-text--inactive]="!(memberProfile.active ?? true)">
                  {{ ((memberProfile.active ?? true) ? 'fee.active' : 'fee.deactivated') | translate }}
                </span>
              </div>

              <div class="card-divider"></div>
              <div class="emergency-section">
                <span class="section-label emergency-title">{{ 'fee.emergency_contact' | translate }}</span>
                @if (memberProfile.emergencyContactName || memberProfile.emergencyContactEmail || memberProfile.emergencyContactPhone) {
                  <div class="field-row"><span class="field-label">{{ 'user_card.name' | translate }}:</span><span class="field-value">{{ memberProfile.emergencyContactName || '—' }}</span></div>
                  <div class="field-row"><span class="field-label">{{ 'fee.mail' | translate }}:</span><span class="field-value">{{ memberProfile.emergencyContactEmail || '—' }}</span></div>
                  <div class="field-row"><span class="field-label">{{ 'fee.phone' | translate }}:</span><span class="field-value">{{ memberProfile.emergencyContactPhone || '—' }}</span></div>
                } @else {
                  <div class="emergency-empty">{{ 'fee.no_emergency_contact_set' | translate }}</div>
                }
                @if (showPaymentModeCard) {
                  <div class="payment-mode-card">
                    <div class="payment-mode-label">
                      {{ 'fee.payment_mode.prefix' | translate }}
                      <strong>{{ paymentModeValueKey | translate }}</strong>
                    </div>
                    @if (isBindingPaymentActive) {
                      <button class="btn-binding-cancel" type="button"
                              [disabled]="cancelingBinding"
                              (click)="cancelRecurringBinding()">
                        @if (cancelingBinding) {
                          <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
                        } @else {
                          <span>{{ 'fee.cancel_binding_payment' | translate }}</span>
                        }
                      </button>
                    }
                  </div>
                }
              </div>
            </div>
          </aside>

          <main class="content-panel">
            @if (memberProfile.subgroups.length > 0) {
              <div class="subgroup-tabs-bar">
                <div class="tabs-scroll" #tabsScroll>
                  @for (sg of memberProfile.subgroups; track sg.id; let i = $index) {
                    <div class="subgroup-tab"
                         [class.tab-offscreen]="i < tabsStartIndex || i >= tabsEndIndex"
                         [class.active]="activeSubgroupId === sg.id" (click)="selectSubgroup(sg.id)">
                      <span class="tab-label">{{ sg.groupName || activeMembership.industryName }} / {{ sg.name }}</span>
                    </div>
                  }
                </div>
                @if (showTabsNavigation) {
                  @if (hasMoreTabsRight) {
                    <button class="btn-trs" (click)="nextPage()">
                      <mat-icon class="nav-to-many">chevron_right</mat-icon>
                    </button>
                  } @else {
                    <button class="btn-trs" (click)="prevPage()">
                      <mat-icon class="nav-to-many">chevron_left</mat-icon>
                    </button>
                  }
                }
              </div>
            }

            @if (activeSubgroup) {
              <div class="subgroup-info-banner desktop-only">
                <div class="info-banner-item"><span class="banner-label">{{ 'fee.mentor_name' | translate }}</span><span class="banner-value">{{ activeSubgroup.mentorName || '—' }}</span></div>
                <div class="info-banner-item"><span class="banner-label">{{ 'fee.start_date_end_date' | translate }}</span><span class="banner-value">{{ formatDateRange(activeSubgroup) }}</span></div>
                <div class="info-banner-item"><span class="banner-label">{{ 'fee.frequency' | translate }}</span><span class="banner-value">{{ frequencyLabel(activeSubgroup.frequency) }}</span></div>
                <div class="info-banner-item"><span class="banner-label">{{ 'fee.price' | translate }}</span><span class="banner-value">{{ activeSubgroup.price | number }} {{ currencySymbol }}</span></div>
                <div class="info-banner-item"><span class="banner-label">{{ 'fee.discount' | translate }}</span><span class="banner-value">{{ discountLabel(activeSubgroup) }}</span></div>
              </div>

              <div class="subgroup-info-mobile mobile-only">
                <button class="subgroup-info-toggle" type="button" (click)="showSubgroupInfoMobile = !showSubgroupInfoMobile">
                  <span>{{ 'fee.subgroup_information' | translate }}</span>
                  <mat-icon class="toggle-chevron">{{ showSubgroupInfoMobile ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                </button>
                @if (showSubgroupInfoMobile) {
                  <div class="subgroup-info-cards">
                    <hr class="subgroup-info-divider">
                    <div class="si-card"><span class="banner-label">{{ 'fee.mentor_name' | translate }}</span><span class="banner-value">{{ activeSubgroup.mentorName || '—' }}</span></div>
                    <div class="si-card"><span class="banner-label">{{ 'fee.start_date_end_date' | translate }}</span><span class="banner-value">{{ formatDateRange(activeSubgroup) }}</span></div>
                    <div class="si-card"><span class="banner-label">{{ 'fee.frequency' | translate }}</span><span class="banner-value">{{ frequencyLabel(activeSubgroup.frequency) }}</span></div>
                    <div class="si-card-row">
                      <div class="si-card si-card--half"><span class="banner-label">{{ 'fee.price' | translate }}</span><span class="banner-value">{{ activeSubgroup.price | number }} {{ currencySymbol }}</span></div>
                      <div class="si-card si-card--half"><span class="banner-label">{{ 'fee.discount' | translate }}</span><span class="banner-value">{{ discountLabel(activeSubgroup) }}</span></div>
                    </div>
                  </div>
                }
              </div>
            }

            <div class="payment-section">
              @if (filteredPaymentRowsView.length > 0) {
                <table class="payment-table desktop-table">
                  <thead>
                    <tr>
                      <th>{{ 'fee.month' | translate }}</th>
                      <th>{{ 'fee.frequency' | translate }}</th>
                      <th>{{ 'fee.price' | translate }}</th>
                      <th>{{ 'fee.discount' | translate }}</th>
                      <th>{{ 'fee.total' | translate }}</th>
                      <th>{{ 'fee.due' | translate }}</th>
                      <th>{{ 'activity.status' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (r of displayedPaymentRows; track r.id) {
                      <tr>
                        <td class="cell-month">{{ r.periodLabel | localizedMonth }}</td>
                        <td>{{ frequencyLabel(r.frequency) }}</td>
                        <td>{{ r.price | number }} {{ currencySymbol }}</td>
                        <td>{{ paymentDiscountLabel(r) }}</td>
                        <td>{{ r.total | number }} {{ currencySymbol }}</td>
                        <td>{{ (isPaidRecord(r) ? 0 : r.due) | number }} {{ currencySymbol }}</td>
                        <td class="cell-action">
                          @if (isPaidRecord(r)) {
                            <span class="status-badge" [ngClass]="paymentStatusViewClass(r)">
                              <mat-icon class="status-icon">{{ paymentStatusIcon(r) }}</mat-icon>
                              {{ paymentStatusLabel(r) }}
                            </span>
                          } @else if (canPayRecord(r)) {
                            <div class="status-action-group">
                                <span class="status-badge" [ngClass]="paymentStatusViewClass(r)">
                                  <mat-icon class="status-icon">{{ paymentStatusIcon(r) }}</mat-icon>
                                  {{ paymentStatusLabel(r) }}
                                </span>
                                <button class="btn-pay" (click)="onPayClick(r)" [disabled]="payingRecordId === r.id">
                                  {{ (payingRecordId === r.id ? 'fee.processing' : 'fee.pay') | translate }}
                                </button>
                              </div>
                            } @else if (isPendingRecord(r)){
                              <span class="status-badge" [ngClass]="paymentStatusViewClass(r)">
                                <mat-icon class="status-icon">{{ paymentStatusIcon(r) }}</mat-icon>
                                {{ paymentStatusLabel(r) }}
                              </span>

                          } @else {
                            <span class="status-badge" [ngClass]="paymentStatusViewClass(r)">
                              <mat-icon class="status-icon">{{ paymentStatusIcon(r) }}</mat-icon>
                              {{ paymentStatusLabel(r) }}
                            </span>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>

                <div class="payment-cards mobile-only">
                  @for (r of displayedPaymentRows; track r.id) {
                    <div class="payment-card">
                      <div class="pc-row-header">
                        <div class="pf-item">
                          <span class="pf-label">{{ 'fee.month' | translate }}</span>
                          <span class="pf-value pf-value--bold">{{ r.periodLabel | localizedMonth }}</span>
                        </div>
                        @if (isPaidRecord(r)) {
                          <span class="status-badge" [ngClass]="paymentStatusViewClass(r)">
                            <mat-icon class="status-icon">{{ paymentStatusIcon(r) }}</mat-icon>
                            {{ paymentStatusLabel(r) }}
                          </span>
                        } @else if (canPayRecord(r)) {
                          <div class="status-action-group">
                              <span class="status-badge" [ngClass]="paymentStatusViewClass(r)">
                                <mat-icon class="status-icon">{{ paymentStatusIcon(r) }}</mat-icon>
                                {{ paymentStatusLabel(r) }}
                              </span>
                              <button class="btn-pay" (click)="onPayClick(r)" [disabled]="payingRecordId === r.id">
                                {{ (payingRecordId === r.id ? 'fee.processing' : 'fee.pay') | translate }}
                              </button>
                            </div>
                        } @else if (isPendingRecord(r)){
                            <span class="status-badge" [ngClass]="paymentStatusViewClass(r)">
                              <mat-icon class="status-icon">{{ paymentStatusIcon(r) }}</mat-icon>
                              {{ paymentStatusLabel(r) }}
                          </span>
                        } @else {
                          <span class="status-badge" [ngClass]="paymentStatusViewClass(r)">
                            <mat-icon class="status-icon">{{ paymentStatusIcon(r) }}</mat-icon>
                            {{ paymentStatusLabel(r) }}
                          </span>
                        }
                      </div>

                      <div class="pf-item">
                        <span class="pf-label">{{ 'fee.frequency' | translate }}</span>
                        <span class="pf-value pf-value--bold">{{ frequencyLabel(r.frequency) }}</span>
                      </div>
                      <div class="pf-item">
                        <span class="pf-label">{{ 'fee.price' | translate }}</span>
                        <span class="pf-value pf-value--bold">{{ r.price | number }} {{ currencySymbol }}</span>
                      </div>
                      <div class="pf-item">
                        <span class="pf-label">{{ 'fee.discount' | translate }}</span>
                        <span class="pf-value pf-value--bold">{{ paymentDiscountLabel(r) }}</span>
                      </div>
                      <div class="pf-item">
                        <span class="pf-label">{{ 'fee.total' | translate }}</span>
                        <span class="pf-value pf-value--bold">{{ r.total | number }} {{ currencySymbol }}</span>
                      </div>
                      <div class="pf-item">
                        <span class="pf-label">{{ 'fee.due' | translate }}</span>
                        <span class="pf-value pf-value--bold">{{ (isPaidRecord(r) ? 0 : r.due) | number }} {{ currencySymbol }}</span>
                      </div>
                    </div>
                  }
                </div>
                @if (hasMorePaymentRows) {
                  <div class="fee-load-more-row d-flex justify-content-center mt-4 flex-direction-row gap-10px">
                    @if (!isLoading) {
                      <button class="load-history-button" type="button" (click)="loadMore()">{{ 'my_team.load_more' | translate }}</button>
                      <div class="search-loader">
                        <div class="spinner-border" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    }
                  </div>
                }
              } @else {
                <div class="detail-state"><p class="detail-empty">{{ 'fee.no_payment_history_for_subgroup' | translate }}</p></div>
              }
            </div>
          </main>
        </div>
      } @else {
        <div class="detail-state">
          <p class="detail-empty">{{ 'fee.select_group_to_view_details' | translate }}</p>
        </div>
      }
    </div>
  </div>

} @else {
  <div class="fee-container">
    <div class="fee-grid">

    @for (industry of industries; track industry.id; let i = $index) {
      <div class="fee-card" [class.selected]="selectedIndex === i" (click)="selectCard(i)">
        <div class="card-icon-box">
          <img [src]="'assets/fee-icons/' + industry.image" [alt]="getIndustryName(industry)" class="card-icon">
        </div>
        <div class="description">
          <h3 class="card-title">{{ getIndustryName(industry) }}</h3>
          <p class="card-description">{{ getIndustrySubtitle(industry) }}</p>
        </div>

          @if (selectedIndex === i) {
            <div class="card-inputs" (click)="$event.stopPropagation()">
              <label class="upload-circle" [for]="'imageUpload-' + i">
                @if (imagePreviewUrl) {
                  <img [src]="imagePreviewUrl" alt="preview" class="upload-circle-preview">
                } @else {
                  <img src="assets/fee-icons/Placeholder.svg" alt="upload" class="upload-placeholder-icon">
                }
                <input [id]="'imageUpload-' + i" type="file" accept=".jpg,.jpeg,.heic,.png" class="image-input" (change)="onImageSelected($event)">
              </label>
              <div class="group-name-wrapper">
                <input type="text" class="group-name-input" [placeholder]="'fee.company_name' | translate" [(ngModel)]="groupName">
                @if (companyNameError) {
                  <span class="input-error">{{ companyNameError | translate }}</span>
                }
              </div>
              @if (logoError) {
                <span class="input-error">{{ logoError | translate }}</span>
              }
            </div>
          }
        </div>
      }

    </div>

    <div class="fee-create-actions flex-direction-row justify-content-end gap-10px mt-3 mr-20px">
      <button class="filled-white-button short-button" [disabled]="selectedIndex === null" (click)="cancel()">{{ 'Cancel' | translate }}</button>
      <button class="filled-button short-button" [disabled]="selectedIndex === null || loading" (click)="save()">{{ 'user_card.save' | translate }}</button>
    </div>
  </div>

  <div class="common-footer fee-create-mobile-footer">
    <button type="button"
            class="fee-create-mobile-btn fee-create-mobile-btn--save"
            [disabled]="selectedIndex === null || loading"
            (click)="save()">
      {{ 'user_card.save' | translate }}
    </button>
    <button type="button"
            class="fee-create-mobile-btn fee-create-mobile-btn--cancel"
            [disabled]="selectedIndex === null"
            (click)="cancel()">
      {{ 'Cancel' | translate }}
    </button>
  </div>

}
